/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { ExpressionDomainModelImpl } from "abreact/expression/domain/ExpressionDomainModelImpl";
import { OperandValueSummaryGeneratorImpl } from "abreact/expression/ui/editor/impl/factory/OperandValueSummaryGeneratorImpl";
import { GuidedExpressionCompactSummaryImpl } from "abreact/expression/ui/editor/impl/utils/GuidedExpressionCompactSummary";
import { ExpressionHooks } from "abreact/expression/utils/ExpressionHooks";
import { AbUnsetValue } from "abreact/form/AbUnsetValue";
import * as AbHooks from "abreact/utils/AbHooks";
import { AbBusyIndicator } from "absdk/commons/ui/misc/AbBusyIndicator";
import React, { useMemo } from "react";
export function GuidedExpressionRenderer(props) {
  const {
    expression,
    expressionAPI,
    notifyContentsResized,
    summaryGenerator
  } = props;
  const expExpressionDefinition = ExpressionHooks.useExpressionDefinition(expression);
  const domainID = expExpressionDefinition?.domainID ?? null;
  const domain = ExpressionHooks.useExpressionDomain(domainID, expressionAPI);
  AbHooks.useOnValueChange(() => {
    notifyContentsResized?.();
  }, domain);
  const expressionDomainModel = useMemo(() => domain && new ExpressionDomainModelImpl(domain), [domain]);
  const valueRenderer = useMemo(() => {
    if (expressionDomainModel) {
      return (summaryGenerator ?? new OperandValueSummaryGeneratorImpl()).getValueRenderer(expressionDomainModel);
    }
  }, [expressionDomainModel, summaryGenerator]);
  if (expExpressionDefinition == null) {
    return /*#__PURE__*/React.createElement(AbUnsetValue, null);
  }
  if (expressionDomainModel == null || valueRenderer == null) {
    return /*#__PURE__*/React.createElement(AbBusyIndicator, {
      delay: props.busyIndicatorDelay ?? 2000,
      size: props.busyIndicatorSize
    });
  }
  return /*#__PURE__*/React.createElement(GuidedExpressionCompactSummaryImpl, {
    expExpressionDefinition: expExpressionDefinition,
    expressionDomainModel: expressionDomainModel,
    valueRenderer: valueRenderer
  });
}
//# sourceMappingURL=GuidedExpressionRenderer.js.map
